module.exports = __webpack_public_path__ + "img/logoSpiegazione.d07c8dd5.jpg";